import { useCallback } from 'react'
import { useMutation } from 'react-query'

import { updateRecurringInvoiceStatus, UpdateRecurringInvoiceStatusOptions } from '../query-api'
import type { RecurringInvoiceDraft } from '../types/recurringInvoiceDraft'

export type SetRecurringInvoiceStatusOptions = UpdateRecurringInvoiceStatusOptions & {
  onError?: () => void
  onSuccess?: (recurringInvoice: RecurringInvoiceDraft) => void
}

export const useSetRecurringInvoiceStatus = () => {
  const { mutate: updateStatus, isLoading: isProcessing } = useMutation(updateRecurringInvoiceStatus)

  const setRecurringInvoiceStatus = useCallback(
    ({ recurringInvoiceId, recurringInvoiceStatus, onError, onSuccess }: SetRecurringInvoiceStatusOptions) => {
      updateStatus(
        {
          recurringInvoiceId,
          recurringInvoiceStatus,
        },
        {
          onError,
          onSuccess: (recurringInvoiceData) => {
            onSuccess?.(recurringInvoiceData?.data)
          },
        },
      )
    },
    [updateStatus],
  )

  return { setRecurringInvoiceStatus, isProcessing }
}
